var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.25C3.27065 4.25 2.57118 4.53973 2.05546 5.05546C1.53973 5.57118 1.25 6.27065 1.25 7V17C1.25 17.7293 1.53973 18.4288 2.05546 18.9445C2.57118 19.4603 3.27065 19.75 4 19.75H20C20.7293 19.75 21.4288 19.4603 21.9445 18.9445C22.4603 18.4288 22.75 17.7293 22.75 17V7C22.75 6.27065 22.4603 5.57118 21.9445 5.05546C21.4288 4.53973 20.7293 4.25 20 4.25H4ZM7.43 8.386C7.26698 8.27962 7.06899 8.24079 6.87787 8.27771C6.68674 8.31464 6.51746 8.42442 6.4058 8.58387C6.29414 8.74331 6.24884 8.93992 6.27948 9.13215C6.31012 9.32438 6.4143 9.49717 6.57 9.614L11.57 13.114C11.696 13.2022 11.8462 13.2495 12 13.2495C12.1538 13.2495 12.304 13.2022 12.43 13.114L17.43 9.614C17.5142 9.55904 17.5865 9.48771 17.6426 9.40425C17.6987 9.32079 17.7374 9.2269 17.7565 9.12817C17.7756 9.02943 17.7746 8.92787 17.7536 8.82952C17.7327 8.73117 17.6921 8.63804 17.6345 8.55567C17.5768 8.4733 17.5031 8.40337 17.4179 8.35005C17.3326 8.29672 17.2375 8.26108 17.1382 8.24525C17.0389 8.22942 16.9374 8.23373 16.8398 8.25791C16.7422 8.28208 16.6504 8.32565 16.57 8.386L12 11.585L7.43 8.386Z",
    fill: "#958060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.f638532331b9bbd26e741e0b3534ccc8.svg";
export { ForwardRef as ReactComponent };